import { useTheme } from "@dehub/theme";
import { Image, Text } from "@mantine/core";
import classes from "./TenantPill.module.css";

export interface TenantPillProps {
  /** md = нэвтрэх хүрээ, ачаалах дэлгэц (34 px); sm = толгой (30 px). */
  size?: "sm" | "md";
}

const LOGO_HEIGHT = { sm: 30, md: 40 } as const;

/** Tenant-ийн лого; лого тохируулаагүй бол нэрийн primary пилл. Аль аль нь алга бол юу ч зурахгүй. */
export function TenantPill({ size = "md" }: TenantPillProps) {
  const { tenant } = useTheme();
  const name = tenant?.name?.trim() ?? "";

  if (tenant?.logo) {
    return (
      <Image
        src={tenant.logo}
        h={LOGO_HEIGHT[size]}
        w="auto"
        maw="100%"
        fit="contain"
        draggable={false}
        alt={name}
      />
    );
  }

  if (!name) return null;

  return (
    <Text span translate="no" className={classes.root} data-size={size}>
      {name}
    </Text>
  );
}
